export const goToUrl = "https://www.corequran.com";

export const topAppBarColor = "#eeeeee";
export const bottomAppBarColor = "#eeeeee";
export const themeColor = "#1a405f";
